import React, {useEffect, useState} from 'react';
import styled from 'styled-components'
import DateBeauty from "./component/date_beauty";
import Teacher from "./component/teacher";


export default function MasterclassItem({
        isDone,
        hasSuscription,
        title,
        teacher,
        slug,
        price,
        isFree,
        hasAccess,
        description,
        startsDay,
        startsMonth,
        starsHour
    }) {
    const [selected, setSelected] = useState(false)

    useEffect(() => {

        const listener = (event) => {
            const slugSelected = event.detail
            setSelected(slug === slugSelected)
        }

        document.addEventListener('masterclass_select', listener)

        return () => {
            document.removeEventListener('masterclass_select', listener)
        }
    }, [slug])

    const selectMasterclass = (slug) => {
        const event = new CustomEvent('masterclass_select', {detail: slug})
        document.dispatchEvent(event)

        window.history.pushState({},'Gauss Online', `/masterclass-tool/${slug}`);
    }


    return (
        <Container
            onClick={() => selectMasterclass(slug)}
            isSelected={selected}
        >

            <Header>
                <Teacher teacher={teacher} />

                <DateBeauty starsHour={starsHour} startsMonth={startsMonth} startsDay={startsDay} />

                <Placeholder />

                <PriceContainer>

                    <PriceIconContainer>
                    {hasAccess || isFree || hasSuscription ? (<IconAccess src="/images/padlock_green.svg"/>) : (
                        <IconAccess src="/images/padlock.svg"/>)}
                    </PriceIconContainer>

                    {(!(hasAccess || isFree || hasSuscription) && !isDone) && (<Price>{price} €</Price>)}
                </PriceContainer>
            </Header>


            <DataContainer>
                <ContentContainer>
                    {isFree && (<IsFreeContainer><IsFreeSpan>GRATIS</IsFreeSpan></IsFreeContainer>)}
                    <Title>{title}</Title>
                    <Description>{description}</Description>
                </ContentContainer>
            </DataContainer>
        </Container>
    )
}

const IsFreeContainer = styled.div`
    padding-bottom: 12px;
`
const IsFreeSpan = styled.span`

    font-size: 10px;
    color: white;
    font-weight: bold;
    padding: 4px;
    border-radius: 16px;
    background-color: #92AC86;

`

const Placeholder = styled.div`
    flex: 1;
`
const Header = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    height: 100px;
`
const Container = styled.div`
    margin-bottom: 12px;
    border: 1px solid ${props => props.isSelected ? 'orange' : 'white'};
    border-radius: 4px;
    padding: 24px 16px;
    cursor: pointer;
    background-color: #1A2024;

    &:hover {
        border: 1px solid #FA9F63;
    }
`

const IconAccess = styled.img`
    width: 24px;
    margin: auto;
`

const ContentContainer = styled.div`
    padding-top: 12px;
    flex: 1;
`
const PriceContainer = styled.div`
    margin-left: 12px;
`

const PriceIconContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding-bottom: 8px;
    height: 100px;
`


const Title = styled.div`
    font-size: 18px;
    color: white;
`

const Description = styled.div`
    padding-top: 4px;
    color: #5F676D;
    font-size: 14px;
`

const Price = styled.div`
    color: white;
    padding-bottom: 8px;
    font-size: 22px;
`
const DataContainer = styled.div`
    display: flex;
    flex-direction: row;

`
